module.exports = __webpack_public_path__ + "static/opener-text-sml-1428c3387677670f68f5224a00b829a2.png";